import { gql } from '@apollo/client';

export const DELETE_FRIEND = gql /* GraphQL */ `
	mutation DeleteFriend($uuid: String!) {
		removeFriend(uuid: $uuid)
	}
`;
